import { render, staticRenderFns } from "./ActivityRedirectToOffice.vue?vue&type=template&id=609b2b74&scoped=true&"
import script from "./ActivityRedirectToOffice.vue?vue&type=script&lang=js&"
export * from "./ActivityRedirectToOffice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609b2b74",
  null
  
)

export default component.exports